import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    gridContainer: {
      display: "flex",
      flex: "1 1 100%",
      flexWrap: "wrap",
      gap: "18px",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
      },
    },
  };
});
